export default __webpack_public_path__ + "locales/lv/SMTPSettings.json?hash=b71daa345fd11bbbe2f88b622451222c";